import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./orgsettings-modal.html';
import 'inputmask';
import UtilsService from '../../services/utils.service';
import DataProvider from "../../app/data-framework/data-provider";

  function OrgSettingsModal(params) {

      var self = this;
      self.id = UtilsService.generateID();

      self.dataProvider = DataProvider.getInstance();

      self.daysPerWeek = ko.observable(5);
      self.hoursPerDay = ko.observable(8);

      self.dataProvider.getOrgPreferences('vAnalyticsOrgPreferences').then(function (orgPrefs) {

          if (orgPrefs && orgPrefs.orgSettings) {
              self.daysPerWeek(orgPrefs.orgSettings.daysPerWeek);
              self.hoursPerDay(orgPrefs.orgSettings.hoursPerDay);
          }

      });

      self.saveOrgSettings = function() {

          self.dataProvider.getOrgPreferences('vAnalyticsOrgPreferences').then(function (orgPrefs) {

              if (!orgPrefs)
                  orgPrefs = {};

              orgPrefs.orgSettings = {daysPerWeek: self.daysPerWeek(), hoursPerDay: self.hoursPerDay()};

              self.dataProvider.saveOrgPreferences('vAnalyticsOrgPreferences', ko.toJS(orgPrefs));
          });

      };
  }


  // This runs when the component is torn down. Put here any logic necessary to clean up,
  // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
  OrgSettingsModal.prototype.dispose = function () { };

  export default { viewModel: OrgSettingsModal, template: templateMarkup };
